import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-d-flex p-flex-row" }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "fa fa-list p-mr-2" }, null, -1)
const _hoisted_3 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_4 = { class: "p-field p-col-12 p-lg-4" }
const _hoisted_5 = { class: "p-float-label" }
const _hoisted_6 = { class: "kn-material-input-label" }
const _hoisted_7 = { class: "p-field p-col-12 p-lg-4" }
const _hoisted_8 = { class: "p-float-label" }
const _hoisted_9 = { class: "kn-material-input-label" }
const _hoisted_10 = { class: "p-field p-col-12 p-lg-4" }
const _hoisted_11 = { class: "p-float-label" }
const _hoisted_12 = { class: "kn-material-input-label" }
const _hoisted_13 = { class: "table-header p-d-flex" }
const _hoisted_14 = { class: "p-input-icon-left p-mr-3 p-col-12" }
const _hoisted_15 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_16 = { class: "kn-cursor-pointer" }
const _hoisted_17 = {
  key: 1,
  class: "kn-cursor-pointer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_Button = _resolveComponent("Button")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Card = _resolveComponent("Card")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Card, { class: "p-m-2 p-d-flex p-flex-column hierarchy-scrollable-card" }, {
      header: _withCtx(() => [
        _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
          start: _withCtx(() => [
            _hoisted_2,
            _createVNode("span", null, _toDisplayString(_ctx.$t('managers.hierarchyManagement.backup')), 1)
          ]),
          _: 1
        })
      ]),
      content: _withCtx(() => [
        _createVNode("form", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("span", _hoisted_5, [
              _createVNode(_component_Dropdown, {
                class: "kn-material-input",
                modelValue: _ctx.selectedDimension,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedDimension = $event)),
                options: _ctx.dimensions,
                optionLabel: "DIMENSION_NM",
                onChange: _ctx.onSelectedDimensionChange
              }, null, 8, ["modelValue", "options", "onChange"]),
              _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('managers.hierarchyManagement.dimensions')), 1)
            ])
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode("span", _hoisted_8, [
              _createVNode(_component_Dropdown, {
                class: "kn-material-input",
                modelValue: _ctx.hierarchyType,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.hierarchyType = $event)),
                options: _ctx.hierarchyManagementHierarchiesCardDescriptor.hierarchyTypes,
                disabled: !_ctx.selectedDimension,
                onChange: _ctx.onHierarchyTypeSelected
              }, null, 8, ["modelValue", "options", "disabled", "onChange"]),
              _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('managers.hierarchyManagement.hierarchyType')), 1)
            ])
          ]),
          _createVNode("div", _hoisted_10, [
            _createVNode("span", _hoisted_11, [
              _createVNode(_component_Dropdown, {
                class: "kn-material-input",
                modelValue: _ctx.selectedHierarchy,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedHierarchy = $event)),
                options: _ctx.hierarchies,
                optionLabel: "HIER_NM",
                disabled: !_ctx.hierarchyType,
                onChange: _ctx.onHierarchySelected
              }, null, 8, ["modelValue", "options", "disabled", "onChange"]),
              _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('managers.hierarchyManagement.hierarchies')), 1)
            ])
          ])
        ]),
        _createVNode(_component_DataTable, {
          value: _ctx.rows,
          class: "p-datatable-sm kn-table",
          "edit-mode": "row",
          "editing-rows": _ctx.editingRows,
          "onUpdate:editing-rows": _cache[5] || (_cache[5] = ($event: any) => (_ctx.editingRows = $event)),
          onRowEditSave: _ctx.updateBackupConfirm,
          filters: _ctx.filters,
          "onUpdate:filters": _cache[6] || (_cache[6] = ($event: any) => (_ctx.filters = $event)),
          globalFilterFields: _ctx.globalFilterFields,
          loading: _ctx.loading,
          responsiveLayout: "stack",
          breakpoint: "700px"
        }, {
          empty: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
          ]),
          header: _withCtx(() => [
            _createVNode("div", _hoisted_13, [
              _createVNode("span", _hoisted_14, [
                _hoisted_15,
                _createVNode(_component_InputText, {
                  class: "kn-material-input",
                  modelValue: _ctx.filters['global'].value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.filters['global'].value = $event)),
                  type: "text",
                  placeholder: _ctx.$t('common.search')
                }, null, 8, ["modelValue", "placeholder"])
              ])
            ])
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
              return (_openBlock(), _createBlock(_component_Column, {
                class: "kn-truncated",
                header: _ctx.$t(column.header),
                key: column.field,
                sortField: column.field,
                sortable: true
              }, {
                body: _withCtx((slotProps) => [
                  _withDirectives(_createVNode("span", _hoisted_16, [
                    _createTextVNode(_toDisplayString(slotProps.data[column.field]), 1)
                  ], 512), [
                    [
                      _directive_tooltip,
                      slotProps.data[column.field],
                      void 0,
                      { top: true }
                    ]
                  ])
                ]),
                editor: _withCtx((slotProps) => [
                  (column.header == 'Name' || column.header == 'Description')
                    ? _withDirectives((_openBlock(), _createBlock(_component_InputText, {
                        key: 0,
                        class: "kn-material-input",
                        modelValue: slotProps.data[column.field],
                        "onUpdate:modelValue": ($event: any) => (slotProps.data[column.field] = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])), [
                        [
                          _directive_tooltip,
                          slotProps.data[column.field],
                          void 0,
                          { top: true }
                        ]
                      ])
                    : _withDirectives((_openBlock(), _createBlock("span", _hoisted_17, [
                        _createTextVNode(_toDisplayString(slotProps.data[column.field]), 1)
                      ], 512)), [
                        [
                          _directive_tooltip,
                          slotProps.data[column.field],
                          void 0,
                          { top: true }
                        ]
                      ])
                ]),
                _: 2
              }, 1032, ["header", "sortField"]))
            }), 128)),
            _createVNode(_component_Column, {
              rowEditor: true,
              style: _ctx.hierarchyManagementDimensionsTableDescriptor.iconColumnStyle
            }, null, 8, ["style"]),
            _createVNode(_component_Column, {
              style: _ctx.hierarchyManagementDimensionsTableDescriptor.iconColumnStyle
            }, {
              body: _withCtx((slotProps) => [
                _withDirectives(_createVNode(_component_Button, {
                  icon: "pi pi-history",
                  class: "p-button-link",
                  onClick: ($event: any) => (_ctx.restoreBackupConfirm(slotProps.data))
                }, null, 8, ["onClick"]), [
                  [
                    _directive_tooltip,
                    _ctx.$t('common.restore'),
                    void 0,
                    { top: true }
                  ]
                ]),
                _withDirectives(_createVNode(_component_Button, {
                  icon: "pi pi-trash",
                  class: "p-button-link",
                  onClick: ($event: any) => (_ctx.deleteBackupConfirm(slotProps.data))
                }, null, 8, ["onClick"]), [
                  [
                    _directive_tooltip,
                    _ctx.$t('common.delete'),
                    void 0,
                    { top: true }
                  ]
                ])
              ]),
              _: 1
            }, 8, ["style"])
          ]),
          _: 1
        }, 8, ["value", "editing-rows", "onRowEditSave", "filters", "globalFilterFields", "loading"])
      ]),
      _: 1
    })
  ]))
}